import { render, staticRenderFns } from "./CellRendererBadge.vue?vue&type=template&id=88020196&scoped=true"
import script from "./CellRendererBadge.vue?vue&type=script&lang=js"
export * from "./CellRendererBadge.vue?vue&type=script&lang=js"
import style0 from "./CellRendererBadge.vue?vue&type=style&index=0&id=88020196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88020196",
  null
  
)

export default component.exports